export enum BadgeVariants {
   Primary = 'PRIMARY'
}

export enum BadgeSizesEnum {
   Medium = 'Medium'
}
